module.exports = __webpack_public_path__ + "static/media/arrow-pointing.d66348a7.svg";